import { render } from "./MapMarker.vue?vue&type=template&id=563a1c2c"
import script from "./MapMarker.vue?vue&type=script&lang=js"
export * from "./MapMarker.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/MapMarker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "563a1c2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('563a1c2c', __exports__)) {
    api.reload('563a1c2c', __exports__)
  }
  
  module.hot.accept("./MapMarker.vue?vue&type=template&id=563a1c2c", () => {
    api.rerender('563a1c2c', render)
  })

}


export default __exports__